import {
  jb_contact_teaser_css_default
} from "./chunk.BNMOG76B.js";
import {
  Spaceable
} from "./chunk.LK5OUX7S.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ChangesBackgroundColor
} from "./chunk.6ORGI2J5.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-contact-teaser/jb-contact-teaser.ts
var JbContactTeaser = class extends ChangesBackgroundColor(Spaceable(r)) {
  constructor() {
    super(...arguments);
    this._fallbackImage = {
      picture: {
        alt: "",
        imgData: {
          sources: {},
          fallbackImage: {
            src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjU0IiBoZWlnaHQ9IjI1NCIgdmlld0JveD0iMCAwIDI1NCAyNTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyNTQiIGhlaWdodD0iMjU0IiByeD0iMTI3IiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyNS41NzcgNTEuOTU0OUMxMjUuNTcgNTEuOTU0OSAxMjUuNTYzIDUxLjk1NDkgMTI1LjU1NiA1MS45NTQ5QzExNy4xODcgNTEuOTU0OSAxMTAuNDAyIDU4LjczOTMgMTEwLjQwMiA2Ny4xMDgzQzExMC40MDIgNzUuNDc3MyAxMTcuMTg3IDgyLjI2MTcgMTI1LjU1NiA4Mi4yNjE3QzEyNS41NTYgODIuMjYxNyAxMjUuNTU2IDgyLjI2MTcgMTI1LjU1NiA4Mi4yNjE3TDEyNS41NTYgODIuMjYxN0wxNjUuOTU5IDgyLjI2MTdDMTY1Ljk2MSA4Mi4yNjE3IDE2NS45NjMgODIuMjYxNyAxNjUuOTY1IDgyLjI2MTdDMTc0LjMzNCA4Mi4yNjE3IDE4MS4xMTggNzUuNDc3MyAxODEuMTE4IDY3LjEwODNDMTgxLjExOCA1OC43MzkzIDE3NC4zMzQgNTEuOTU0OSAxNjUuOTY1IDUxLjk1NDlMMTI1LjU3NyA1MS45NTQ5WiIgZmlsbD0iI0U4RTVEMiIgZmlsbC1vcGFjaXR5PSIwLjUiLz4KPHBhdGggZD0iTTE2My4wNzkgOTEuNjQyNkwxNTEuNTMzIDgyLjI2MTlMMTYzLjA3OSA4Mi4yNjE5TDE2My4wNzkgOTEuNjQyNloiIGZpbGw9IiNFOEU1RDIiIGZpbGwtb3BhY2l0eT0iMC41Ii8+CjxjaXJjbGUgY3g9Ijk4LjEzNDkiIGN5PSI1MS45NTUzIiByPSIyMi4zNjkzIiBmaWxsPSIjRThFNUQyIiBmaWxsLW9wYWNpdHk9IjAuNSIvPgo8cGF0aCBvcGFjaXR5PSIwLjYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjUzLjQxNSAxMTQuNzM0QzI1My44MDIgMTE4Ljc3MSAyNTQgMTIyLjg2MyAyNTQgMTI3LjAwMUMyNTQgMTU0LjEyIDI0NS41IDE3OS4yNTMgMjMxLjAxOSAxOTkuODgySDg1LjE0ODRWMTE0LjczNEgyNTMuNDE1WiIgZmlsbD0iI0YzRjNFQyIvPgo8cGF0aCBkPSJNMTQ0LjMxOCAxMDIuMjczSDE4MS4zMTQiIHN0cm9rZT0iIzI2MzU4QyIgc3Ryb2tlLXdpZHRoPSIxLjQ2NjU4Ii8+CjxwYXRoIGQ9Ik0xNDQuODQ2IDEwNi42ODdIMTc4LjE0MiIgc3Ryb2tlPSIjMjYzNThDIiBzdHJva2Utd2lkdGg9IjEuNDY2NTgiLz4KPHBhdGggZD0iTTE0NC44NDYgMTE5LjkxNkgxNzguMTQyIiBzdHJva2U9IiMyNjM1OEMiIHN0cm9rZS13aWR0aD0iMS40NjY1OCIvPgo8cGF0aCBkPSJNMTQ0Ljg0NiAxMTEuMDg2SDE4MS44NDEiIHN0cm9rZT0iIzI2MzU4QyIgc3Ryb2tlLXdpZHRoPSIxLjQ2NjU4Ii8+CjxwYXRoIGQ9Ik0xNDQuODQ2IDEyOC43M0gxODEuODQxIiBzdHJva2U9IiMyNjM1OEMiIHN0cm9rZS13aWR0aD0iMS40NjY1OCIvPgo8cGF0aCBkPSJNMTQ0Ljg0NiAxMTUuNTAySDE3My45MTQiIHN0cm9rZT0iIzI2MzU4QyIgc3Ryb2tlLXdpZHRoPSIxLjQ2NjU4Ii8+CjxwYXRoIGQ9Ik0xNDQuODQ2IDEyNC4zMTRIMTczLjkxNCIgc3Ryb2tlPSIjMjYzNThDIiBzdHJva2Utd2lkdGg9IjEuNDY2NTgiLz4KPGVsbGlwc2UgY3g9IjE0OC41NDUiIGN5PSIxMzkuMzEzIiByeD0iMy42OTk1NyIgcnk9IjMuNzAzOTQiIGZpbGw9IiMyNjM1OEMiLz4KPHJlY3Qgb3BhY2l0eT0iMC41IiB4PSIxMTQuMDEyIiB5PSIxNzguOTU1IiB3aWR0aD0iNjAuNjEzNiIgaGVpZ2h0PSIzOC45NjU5IiBmaWxsPSIjQkZDNEUxIi8+CjxwYXRoIGQ9Ik0xNzQuNjI1IDE3OC45NTVIMTE0LjAxMkwxNDQuMzE5IDE1Mi45NzhMMTc0LjYyNSAxNzguOTU1WiIgZmlsbD0iIzgwODlDNCIgZmlsbC1vcGFjaXR5PSIwLjMiLz4KPHBhdGggZD0iTTE3NC42MjUgMTc4Ljk1NUgxMTQuMDEyTDE0NC4zMTkgMTk5LjE2TDE3NC42MjUgMTc4Ljk1NVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xNzQuNjI1IDIxNy45MjJIMTE0LjAxMkwxNDQuMzE5IDE5OS44ODJMMTc0LjYyNSAyMTcuOTIyWiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC4yIi8+CjxlbGxpcHNlIHJ4PSI5LjAwNzI3IiByeT0iOS4wNDg0NCIgdHJhbnNmb3JtPSJtYXRyaXgoLTEgMCAwIDEgNjMuODMwNiA3Mi41NDg0KSIgZmlsbD0iI0JGQzRFMSIvPgo8ZWxsaXBzZSByeD0iNy43MjA1MiIgcnk9IjcuNzU1OCIgdHJhbnNmb3JtPSJtYXRyaXgoLTEgMCAwIDEgNzIuNjY0MiAxMzAuMjU2KSIgZmlsbD0iIzgwODlDNCIvPgo8ZWxsaXBzZSByeD0iNy43MjA1MiIgcnk9IjcuNzU1OCIgdHJhbnNmb3JtPSJtYXRyaXgoLTEgMCAwIDEgNDkuNTcyNSAxMDEuNzQ0KSIgZmlsbD0iI0U4RTVEMiIvPgo8cGF0aCBkPSJNNjMuODI4IDcyLjc5MUwxMTIuNzI1IDExOS42MTkiIHN0cm9rZT0iI0IwQUE3RSIgc3Ryb2tlLXdpZHRoPSIxLjc4MzIyIi8+CjxwYXRoIGQ9Ik01MC43MjAzIDEwMS43NDRMMTEyLjcyNSAxMTkuNjE3IiBzdHJva2U9IiNCMEFBN0UiIHN0cm9rZS13aWR0aD0iMS43ODMyMiIvPgo8cGF0aCBkPSJNNzIuMjM0MyAxMjkuODI1TDEwNC44MzIgMTE2Ljg5OCIgc3Ryb2tlPSIjQjBBQTdFIiBzdHJva2Utd2lkdGg9IjEuNzgzMjIiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMDQuMzg2IDEwNC4wODZDMTA3LjA4IDEwMy41MDcgMTA5Ljk3NyAxMDMuNzM3IDExMi42OTkgMTA0LjkyNUMxMTkuNTg0IDEwNy45MzIgMTIyLjczNyAxMTUuOTMzIDExOS43NCAxMjIuNzk1QzExNi43NDMgMTI5LjY1OCAxMDguNzMyIDEzMi43ODQgMTAxLjg0NyAxMjkuNzc4Qzk5LjEyNTYgMTI4LjU4OSA5Ni45ODc0IDEyNi42MjEgOTUuNTgxNCAxMjQuMjUxTDEwNC4zODYgMTA0LjA4NloiIGZpbGw9IiM4MDg5QzQiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04Mi4yMzYxIDE1NS4wNDNDODQuOTMgMTU0LjQ2NCA4Ny44MjcxIDE1NC42OTQgOTAuNTQ4NCAxNTUuODgyQzk3LjQzMzkgMTU4Ljg4OSAxMDAuNTg2IDE2Ni44OSA5Ny41ODk3IDE3My43NTJDOTQuNTkzMSAxODAuNjE1IDg2LjU4MjEgMTgzLjc0MSA3OS42OTY2IDE4MC43MzVDNzYuOTc1MyAxNzkuNTQ2IDc0LjgzNzEgMTc3LjU3OCA3My40MzExIDE3NS4yMDhMODIuMjM2MSAxNTUuMDQzWiIgZmlsbD0iIzgwODlDNCIvPgo8cGF0aCBvcGFjaXR5PSIwLjUiIGQ9Ik03OS41MzE0IDE4MS4xMTNDODYuNDIxMiAxODQuMTIxIDk0LjQyOTYgMTgwLjk5IDk3LjQyNDYgMTc0LjEzMUwxMTkuODI0IDEyMi44MzJDMTIyLjgyMyAxMTUuOTY1IDExOS42NjQgMTA3Ljk2NyAxMTIuNzgzIDEwNC45NjJMNzkuNTMxNCAxODEuMTEzWiIgZmlsbD0iIzAwMTQ4OSIvPgo8cmVjdCBvcGFjaXR5PSIwLjUiIHdpZHRoPSI0LjMyOTU1IiBoZWlnaHQ9IjgyLjk4MyIgdHJhbnNmb3JtPSJtYXRyaXgoLTAuOTE2NDQzIC0wLjQwMDE2NiAtMC40MDAxNjYgMC45MTY0NDMgMTE2LjY1MiAxMDYuNjUyKSIgZmlsbD0iI0JGQzRFMSIvPgo8L3N2Zz4K"
          }
        }
      }
    };
  }
  render() {
    return ke`
      <div class=${Rt({ small: this.variant === "small" })}>
        <div class="contact-teaser-inner">
          ${this.headline ? ke`<div class="headline-wrapper">
                <h2>${this.headline}</h2>
              </div>` : D}
          <div class="image-wrapper">
            ${this.image ? ke`
                  <jb-image
                    .caption=${this.image.caption}
                    .credit=${this.image.credit}
                    .picture=${this.image.picture}
                    .text=${this.image.text}
                  ></jb-image>
                ` : ke`<jb-image .picture=${this._fallbackImage.picture}></jb-image>`}
          </div>
        </div>
        <jb-button-panel .align=${"center"}><slot></slot></jb-button-panel>
      </div>
    `;
  }
};
JbContactTeaser.styles = jb_contact_teaser_css_default;
__decorateClass([
  n()
], JbContactTeaser.prototype, "headline", 2);
__decorateClass([
  n({ type: Object })
], JbContactTeaser.prototype, "image", 2);
__decorateClass([
  n()
], JbContactTeaser.prototype, "variant", 2);
JbContactTeaser = __decorateClass([
  customElement("jb-contact-teaser")
], JbContactTeaser);

export {
  JbContactTeaser
};
